import React, { type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string | JSX.Element
  error?: string
  inputClassName?: string
  labelClassName?: string
}

function FormInput({
  label,
  value,
  onChange,
  onFocus,
  maxLength,
  error,
  placeholder,
  required,
  className,
  inputClassName,
  labelClassName,
  name,
  type = 'text',
  disabled,
  spellCheck = false,
  autoComplete,
  autoCapitalize,
  ...rest
}: InputProps): ReactNode {
  return (
    <label
      className={twMerge('flex flex-col gap-1 text-sm font-medium text-text-primary', className)}
    >
      {(label || required) && (
        <div className="flex gap-0.5">
          {label && <span className={labelClassName}>{label}</span>}
          {required && <span className="text-red">*</span>}
        </div>
      )}
      <input
        className={twMerge(
          'mt-1 w-full rounded-lg border px-4 py-2.5 main-transition-colors focus:outline-hidden focus-visible:border-brand-primary',
          error ? 'border-danger' : 'border-text-secondary/30',
          inputClassName,
        )}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        maxLength={maxLength}
        placeholder={placeholder}
        spellCheck={spellCheck}
        autoComplete={autoComplete}
        autoCapitalize={autoCapitalize}
        disabled={disabled}
        {...rest}
      />
      {error && <p className="mt-2 text-sm text-danger">{error}</p>}
    </label>
  )
}

export default FormInput
